import { render, staticRenderFns } from "./WeChatApplet.vue?vue&type=template&id=9c2cc232&scoped=true"
import script from "./WeChatApplet.vue?vue&type=script&lang=js"
export * from "./WeChatApplet.vue?vue&type=script&lang=js"
import style0 from "./WeChatApplet.vue?vue&type=style&index=0&id=9c2cc232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2cc232",
  null
  
)

export default component.exports